<!-- TODO: https://ixsystems.atlassian.net/browse/NAS-116793 -->
<!-- TODO: Remove me -->
<ix-icon *ngIf="isRoot" name="ix:dataset"></ix-icon>
<ix-icon *ngIf="!isRoot" [name]="name"></ix-icon>
